import React, { useEffect, useMemo, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { LifeBuoy, MessageSquare, ShieldAlert } from "lucide-react";
import { Button } from "../../../components/ui/button";
import moment from "moment";


const MetricCard = ({ label, value, change, isGoodWhenUp, icon }) => {
//   const isPositiveChange = change?.includes('+');
//   const isGoodChange = isGoodWhenUp ? isPositiveChange : !isPositiveChange;
  
  return (
    <div className="flex items-center bg-[#232834] p-12 rounded-lg">
      <div className="mr-12">
        {icon}
      </div>
      <div className="flex-1">
        <p className="text-sm text-gray-400">{label}</p>
        <div className="flex items-center justify-between">
          <p className="text-xl font-bold">{value}</p>
          {/* <p className={`text-sm ${isGoodChange ? 'text-green-400' : 'text-red-400'} flex items-center`}>
            {isPositiveChange ? 
              <TrendingUp className="h-4 w-4 mr-1" /> : 
              <TrendingDown className="h-4 w-4 mr-1" />}
            {change}
          </p> */}
        </div>
      </div>
    </div>
  );
};


const  getFilteredData = (data = [], range = "today", source = "") => {
  if (!Array.isArray(data) || data.length === 0) return [];

  const now = moment();
  const todayStart = now.clone().startOf("day");

  return data?.filter((item) => {
    let dateField;

    switch (source) {
      case "notifications":
      case "issues":
        dateField = item?.createdOn;
        break;
      case "supplies":
        dateField = item?.createdAt;
        break;
      default:
        return false;
    }

    if (!dateField) return false;

    const date = moment(dateField?.toDate ? dateField.toDate() : dateField);

    switch (range) {
      case "today":
        return date.isSame(todayStart, "day");
      case "yesterday":
        return date.isSame(moment().subtract(1, "day"), "day");
      case "7days":
        return date.isAfter(now.clone().subtract(7, "days"));
      case "30days":
        return date.isAfter(now.clone().subtract(30, "days"));
      case "90days":
        return date.isAfter(now.clone().subtract(90, "days"));
      default:
        return false;
    }
  });
}


const SystemAlerts = ({ dateFilter, data }) => {
const [alertData, setAlertData] = useState();

const filteredData = useMemo(() => {
  return {
    filteredNotifications: getFilteredData(data?.notificationRes?.data, dateFilter, "notifications"),
    filteredIssues: getFilteredData(data?.issueRes?.data, dateFilter, "issues"),
    filteredSupplies: getFilteredData(data?.suppliesRes?.data, dateFilter, "supplies"),
  };
}, [data, dateFilter]);

useEffect(() => {
  setAlertData(filteredData);
}, [filteredData]);

  return (
    <Card className="bg-[#2c3440] dark:bg-[#1A1F2C] text-white border-none shadow-lg hover:shadow-xl transition-all lg:col-span-1 p-24 h-[500px] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <CardHeader className="pb-8">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl font-bold text-white flex items-center">
            <ShieldAlert className="h-5 w-5 mr-8 text-[#9b87f5]" />
            System Alerts
          </CardTitle>
          <Button variant="link" className="text-[#1EAEDB]" asChild>
            <a href="/accounts" style={{ color: "#1EAEDB" }}>View All</a>
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <MetricCard 
            label="Issue Alerts" 
            value={alertData?.filteredIssues?.length} 
            change={alertData?.filteredIssues?.length} 
            isGoodWhenUp={false}
            icon={<ShieldAlert className="h-8 w-8 text-yellow-500" />}
          />
          <MetricCard 
            label="Supplies Tickets" 
            value={alertData?.filteredSupplies?.length} 
            change={alertData?.filteredSupplies?.length} 
            isGoodWhenUp={false}
            icon={<LifeBuoy className="h-8 w-8 text-red-500" />}
          />
          <MetricCard 
            label="Unread Messages" 
            value={alertData?.filteredNotifications?.length} 
            change={alertData?.filteredNotificationsChange?.length} 
            isGoodWhenUp={false}
            icon={<MessageSquare className="h-8 w-8 text-blue-500" />}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default SystemAlerts;